import { useMediaQuery } from '@vueuse/core'

/** Phones get the iMessage-style chat; the same breakpoint Home uses for its mobile layout. */
export const CHAT_PHONE_QUERY = '(max-width: 639px)'

/**
 * Single decision for whether a conversation renders as the iMessage-style
 * chat (bubbles, no avatars or day dividers).
 *
 * This is only the visual style. Whether the transcript also hides its own
 * composer and runs under host chrome is the separate `chatChrome` prop on
 * ConversationSurface; hosts that don't supply a composer (assistant panel,
 * inbox overlay, CRM review) still get bubbles from here.
 */
export function useChatChrome() {
    const isPhone = useMediaQuery(CHAT_PHONE_QUERY)
    return { isPhone }
}

export default useChatChrome
